import { supabase } from '@/lib/supabase'

const KEY_ENGINE = 'candles_engine'
const KEY_MARKET_DEFAULT = 'candles_market_default'

export type CandlesEngine = 'rest_v1' | 'ws_v2'
export type MarketCategory = 'linear' | 'spot' | 'inverse' | 'option'

export async function getCandlesEngine(): Promise<CandlesEngine> {
  const { data, error } = await supabase
    .from('app_settings')
    .select('value')
    .eq('key', KEY_ENGINE)
    .maybeSingle()
  if (error) throw error
  const v = (data?.value as string) || 'ws_v2'
  return (v === 'rest_v1' ? 'rest_v1' : 'ws_v2')
}

export async function setCandlesEngine(engine: CandlesEngine): Promise<void> {
  const { error } = await supabase
    .from('app_settings')
    .upsert({ key: KEY_ENGINE, value: engine }, { onConflict: 'key' })
  if (error) throw error
}

export async function getDefaultMarketCategory(): Promise<MarketCategory> {
  const { data, error } = await supabase
    .from('app_settings')
    .select('value')
    .eq('key', KEY_MARKET_DEFAULT)
    .maybeSingle()
  if (error) throw error
  const v = (data?.value as string) || 'linear'
  if (v === 'spot' || v === 'inverse' || v === 'option') return v
  return 'linear'
}

export async function setDefaultMarketCategory(category: MarketCategory): Promise<void> {
  const { error } = await supabase
    .from('app_settings')
    .upsert({ key: KEY_MARKET_DEFAULT, value: category }, { onConflict: 'key' })
  if (error) throw error
}

